/* =============================================================================
=    Configuration Summary
============================================================================= */
import { gql } from '@apollo/client';

export default gql`
query configurationSummary($configurationInput: ConfigurationInput!) {
  configurationSummary(configurationInput: $configurationInput) {
    vehicleModel {
      id
      brand
      year
      region
      name
      model
      fullModelCode
      edition
      assetPath
      active
      vehicleMarketStatusDesc
      basePrice
      depositAmount
      preorderDepositAmount
      reserveSpotCap
      isWaitlistAllowed
    }
    vehicleOptions {
      id
      price
      currency
      active
      isHidden
      vehicleOptionType {
        id
        categoryCode
        categoryName
        typeCode
        typeName
      }
      createdBy
    }
    basePrice
    subtotal
    preorderDepositAmount
    dueAmount
    preorderPaidAmount
    preorderBalance
  }
}
`;
